<div class="theme-input-mobile">
  <input #whoInput type="number" pattern="[0-9]*" inputmode="numeric" class="input who" [value]="value <= 1 ? null : value + (activeInput !== 'who' ? ' guests' : '')" type="text" (change)="doUpdate($event)" placeholder="By myself" (focus)="setFocus(true)" (blur)="setFocus(false)">
  <span class="input-icon">
    <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/person.svg"></svg-icon>
  </span>
  <span class="input-end">
    <button [disabled]="value <= 1" (click)="decrement()">
      <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/minus.svg"></svg-icon>
    </button>
    <div class="count">
      <span>
        {{ value }}
      </span>
    </div>
    <button (click)="increment()">
      <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/plus.svg"></svg-icon>
    </button>
  </span>
</div>
